import { NudosGenericModal, NudosModalContent } from '../../../../../components/NudosComponents';
import DeliveredLogisticsModalContent from './DeliveredLogisticsModalContent';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData } from '../../../../../types/services';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';
import './DeliveredLogisticsModal.scss';

const DeliveredLogisticsModal = ({
  closeAndRestoreList,
  closeModalAfterSubmitCallback,
  selectedLogisticServiceDataForModal,
  logisticServiceDetails,
  changeLogisticServiceStatusCallback,
  modalButtonIsLoading
}: {
  closeAndRestoreList: () => void;
  closeModalAfterSubmitCallback: () => void;
  selectedLogisticServiceDataForModal: IlogisticServiceTrelloCardData;
  logisticServiceDetails?: IlogisticServiceDetails;
  changeLogisticServiceStatusCallback: TchangeLogisticServiceStatusCallback;
  modalButtonIsLoading?: boolean;
}) => {
  return (
    <div className="DeliveredLogisticsModal">
      <NudosGenericModal
        closeModalCallback={closeAndRestoreList}
        modalContent={
          <NudosModalContent
            toCloseModal={closeAndRestoreList}
            customWidth="780px"
            customHeight="580px"
            modalContentTitle="Pasar a entregado"
            CustomModalComponent={
              <DeliveredLogisticsModalContent
                selectedLogisticServiceDataForModal={selectedLogisticServiceDataForModal}
                logisticServiceDetails={logisticServiceDetails}
                changeLogisticServiceStatusCallback={changeLogisticServiceStatusCallback}
                closeModalAfterSubmitCallback={closeModalAfterSubmitCallback}
                modalButtonIsLoading={modalButtonIsLoading}
              />
            }
          />
        }
      />
    </div>
  );
};

export default DeliveredLogisticsModal;
